<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button class="mr" type="primary" icon="ios-add-circle-outline" @click="addSchoolJobShow">新增图片</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,0)">停用</Button>
					<Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
						@click="updateSchoolStatus(row.id,1)">启用</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">

				<FormItem label="图片" prop="imgUrl">
					<Upload :action="uploadFile" name="file" :on-success="logoImgBack" :data="uploadData"
						accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传图片</Button>
					</Upload>
				</FormItem>
				<FormItem label="类型">
					<RadioGroup v-model="addForm.type">
						<Radio :label="1">轮播图</Radio>
						<Radio :label="2">客服码</Radio>
						<Radio :label="3">一键投递</Radio>
						<Radio :label="4">B端发布客服码</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="落地页链接">
					<Input v-model="addForm.linkUrl" maxlength="100" placeholder="请输入落地页链接" clearable></Input>
				</FormItem>
				<FormItem label="排序">
					<Input type="number" v-model="addForm.sortIndex" placeholder="请输入排序(数值越大越靠前)"></Input>
				</FormItem>
				<FormItem label="状态">
					<i-switch v-model="addForm.status==1" size="large" @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrEditData">确认提交</Button>
			</div>
		</Modal>


	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				uploadData: {
					filePath: 'img'
				},
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					imgUrl: '',
					linkUrl: '',
					sortIndex: 0,
					status: 0,
					type:1,
				},
				addRule: {
					imgUrl: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur',
					}]
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '类型',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.type;
							if (val == 1) {
								name = '轮播图'
							} else if (val == 2) {
								name = '客服码'
							} else {
								name = '一键投递'
							}
							return h('span', name)
						}
					},
					{
						title: '图片链接',
						width: 350,
						key: 'imgUrl',
						align: 'center'
					},
					{
						title: '落地页链接',
						width: 350,
						key: 'linkUrl',
						align: 'center'
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == 1) {
								name = '启用'
							} else {
								name = '停用'
							}
							return h('span', name)
						}
					}, {
						title: '创建日期',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}

				]
			},

		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.schoolJobImgPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			logoImgBack(response, file, fileList) {
				this.addForm.imgUrl = response.data.url
			},
			addSchoolJobShow() {
				this.addForm = {
					id: undefined,
					imgUrl: '',
					linkUrl: '',
					sortIndex: 0,
					status: 0,
					type:1,
				}
				this.addJobShow = true
			},
			addOrEditData(row) {
				const that = this
				let addData = this.addForm
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						api.statistics
							.addOrEditSchoolJobImg(addData)
							.then(res => {
								that.addJobShow = false
								that.refreshData()
							})
					}
				})
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
			updateSchoolStatus(id, status) {
				const that = this
				api.statistics
					.updateSchoolJobImgStatus({
						'id': id,
						status: status
					})
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			editData(data) {
				this.addForm = data
				this.addJobShow = true
			},

		},

	}
</script>
<style>
	.detail {
		display: flex;
		flex-direction: row;
	}
</style>